module.exports = __webpack_public_path__ + "img/Logo2_Barragan.183d69c3.png";